import React, { useState } from 'react';
import { AiOutlineMinus, AiOutlinePlus } from 'react-icons/ai';
const SingleQuestion = ({title,info}) => {
  const [open,setOpen]=useState(false)
 
  return( 
        <article className="question3">
            <header>
              <h4>{title}</h4>
              <button className="btn3" onClick={()=>{setOpen(!open)}}>{open ? <AiOutlineMinus/>:<AiOutlinePlus/>}</button>
             
            </header>
            {open? <p className="info3">{info}</p>:null}
        </article>
  );
};

export default SingleQuestion;
